import { useEffect,useState } from 'react';
import { Link } from 'react-router';
import { api } from '../api';
import { formatActivityTime } from '../dates';

type TimelineItem={id:string;event_at:string;source_type:string;reference:string;title:string;status:string;path:string};
type Scope={developmentId?:string;propertyNodeId?:string;premisesId?:string;assetId?:string;personId?:string;organisationId?:string};

export function TimelinePanel(scope:Scope){const[items,setItems]=useState<TimelineItem[]>([]);const[error,setError]=useState(false);const[expanded,setExpanded]=useState(false);const query=new URLSearchParams(Object.entries(scope).filter((entry):entry is [string,string]=>Boolean(entry[1]))).toString();useEffect(()=>{setExpanded(false);api<TimelineItem[]>(`/api/timeline?${query}&limit=30`).then(setItems).catch(()=>setError(true));},[query]);
  if(error||!items.length)return null;const visible=expanded?items:items.slice(0,5);return <section className="panel building-section">
      <div className="section-heading">
      <div>
      <h2>Recent activity</h2>
      <p>Recent communications, documents and operational activity linked to this record.</p>
      </div>
      <span>{items.length}</span>
      </div>
      <div className="entity-timeline">{visible.map(item=>
      <Link to={item.path} key={`${item.source_type}-${item.id}`}>
      <time>{formatActivityTime(item.event_at)}</time>
      <div>
      <span className="eyebrow">{item.source_type} · {item.reference}</span>
      <strong>{item.title}</strong>
      </div>
      <span className="badge">{item.status}</span>
      </Link>)}</div>{items.length>5&&<button className="secondary" type="button" onClick={()=>setExpanded(value=>!value)}>{expanded?'Show recent only':'View full history'}</button>}</section>;
}
